import { Store } from 'pullstate';
import { UserDetailsI } from '../utiles/interfaces'

const user: UserDetailsI = {
    email: "",
    id: null,
    name: "",
    phone: null,
    phone1: "",
    phone2: "",
    role: null,
    status: "",
    isAdmin: false
}
export const UserStore = new Store( user );
